import { toNumber } from '../../../../core/utils/helperFunc';

// Enum của BE: services/fulfillment_be/api/fulfillment/v1/enum.proto
export const WARRANTY_STATUS = {
  ACTIVE: 'active',
  EXPIRED: 'expired',
  INVALIDATED: 'invalidated',
};

const BE_STATUS_TO_UI = {
  WARRANTY_NOTES_STILL_VALIDATED: WARRANTY_STATUS.ACTIVE,
  WARRANTY_NOTES_EXPIRED: WARRANTY_STATUS.EXPIRED,
  WARRANTY_NOTES_INVALIDATED: WARRANTY_STATUS.INVALIDATED,
};

const BE_DATE_UNIT_TO_UI = {
  DATE_UNIT_MONTH: 'month',
  DATE_UNIT_DAY: 'day',
  DATE_UNIT_YEAR: 'year',
};

// API trả giờ UTC. Phải khoá múi giờ VN chứ không theo máy người xem: mua lúc 18:00 UTC thì ở VN
// đã sang ngày hôm sau, để máy tự quyết định sẽ lệch 1 ngày với người dùng ở nước ngoài.
const dateFormatter = new Intl.DateTimeFormat('vi-VN', {
  timeZone: 'Asia/Ho_Chi_Minh',
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
});

const formatDate = (isoString) => {
  if (!isoString) return null;
  const date = new Date(isoString);
  return Number.isNaN(date.getTime()) ? null : dateFormatter.format(date);
};

// warrantyPeriod là Int64Value (nullable), proto3 JSON trả dạng chuỗi — toNumber lo cả null lẫn chuỗi rỗng.
const mapWarrantyPeriod = (value, beUnit) => {
  if (!beUnit || beUnit === 'DATE_UNIT_UNSPECIFIED') return null;
  const numberValue = toNumber(value);
  if (numberValue === null) return null;
  // Đơn vị lạ (BE thêm mới) thì giữ nguyên giá trị enum để còn hiện ra được.
  return { value: numberValue, unit: BE_DATE_UNIT_TO_UI[beUnit] ?? beUnit };
};

// Thiếu hẳn field status là chuyện bình thường: STILL_VALIDATED là giá trị 0 của proto3, gateway tắt
// EmitUnpopulated thì field biến mất khỏi JSON. Còn status có giá trị nhưng FE chưa biết thì KHÔNG
// được đoán thành "còn bảo hành" — giữ nguyên enum để hiện thẳng ra.
const mapStatus = (beStatus) => {
  if (beStatus === null || beStatus === undefined || beStatus === '') return WARRANTY_STATUS.ACTIVE;
  return BE_STATUS_TO_UI[beStatus] ?? beStatus;
};

const mapWarrantyInfo = (warrantyInfo) => ({
  serial: warrantyInfo.serialImei,
  productName: warrantyInfo.productName,
  sku: warrantyInfo.sku,
  manufacturer: warrantyInfo.manufacturer,
  warrantyPeriod: mapWarrantyPeriod(warrantyInfo.warrantyPeriod, warrantyInfo.warrantyPeriodUnit),
  purchaseDate: formatDate(warrantyInfo.purchasedAt),
  expiryDate: formatDate(warrantyInfo.expiredAt),
  status: mapStatus(warrantyInfo.status),
});

export const mapWarrantyResult = (result) => {
  // NOT_EXIST là phiếu không tồn tại, cùng ý nghĩa với lỗi "không tìm thấy" của API.
  if (!result?.found || !result.warrantyInfo || result.warrantyInfo.status === 'WARRANTY_NOTES_NOT_EXIST') {
    return { notFound: true };
  }
  return { data: mapWarrantyInfo(result.warrantyInfo) };
};
